<app-loader></app-loader>
<div *ngIf="!loading" [class.blur-strong]="misdatos.perfilPublico == 'no_publico'">
  <div class="bg-white rounded-4 mb-3 p-3 position-relative div-shadow" *ngIf="!publicar">
    <div class="row align-items-center">
      <div class="col-6 col-md mb-2">
        <a class="pointer custom-link a-dark" (click)="publicarPaseo()">
          <i class="fa-solid fa-walking me-1"></i>Publicar paseo
        </a>
      </div>
      <div class="col-6 col-md mb-2 text-end">
        {{paseos.length}} paseos
      </div>
      <div class="col-12 col-md">
        <input 
          type="text" 
          class="form-control" 
          placeholder="Buscar..." 
          [(ngModel)]="busqueda">
      </div>
    </div>
  </div>

  <div class="bg-white rounded-4 mb-3 ps-3 pt-3 pe-3 pb-2 position-relative div-shadow" *ngIf="publicar">
    <app-newedit [paseo]="paseo"></app-newedit>
  </div>

  <div class="row align-items-stretch g-3" *ngIf="!publicar && paseos.length > 0">
    <div class="col-12 col-sm-6 col-md-4" *ngFor="let paseo of filtrarPaseos()">
      <app-paseo [paseo]="paseo"></app-paseo>
    </div>
  </div>
</div>
<div *ngIf="loading" class="bg-white rounded-4 mb-3 p-3 text-iguau div-shadow">
  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
  Buscando paseos... 
</div>
